import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import PageHero from '@/components/shared/PageHero';
import SectionHeader from '@/components/shared/SectionHeader';
import { publicApi } from '@/lib/api';
import useSEO from '@/hooks/useSEO';
import CSRProposalCard from '@/pages/csr/CSRProposalCard';

export default function CSRProposalProjectsPage() {
    const [proposals, setProposals] = useState([]);

    useSEO({
        title: 'Proposal Projects',
        description:
            'Ready-to-fund CSR proposal projects from VVVSI Trust — curated initiatives aligned with Schedule VII and SDG mandates.',
    });

    useEffect(() => {
        publicApi.getProposalProjects().then(setProposals).catch(() => {});
    }, []);

    return (
        <div data-testid="csr-proposal-projects-page">
            <PageHero
                eyebrow="CSR Projects"
                title="Proposal Projects"
                subtitle="Ready-to-fund initiatives curated for corporate CSR partners — aligned with Schedule VII and SDG mandates."
            />

            <section className="section-pad">
                <div className="container-page">
                    <SectionHeader
                        eyebrow="Ready-to-fund"
                        title="Curated proposals for CSR partners."
                        description="Each proposal comes with clear budget, timeline, beneficiaries and target outcomes."
                    />
                    {proposals.length > 0 ? (
                        <div
                            className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5"
                            data-testid="proposal-projects-grid"
                        >
                            {proposals.map((pp, i) => (
                                <motion.div
                                    key={pp.id}
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4, delay: i * 0.05 }}
                                    viewport={{ once: true, margin: '-40px' }}
                                >
                                    <CSRProposalCard pp={pp} />
                                </motion.div>
                            ))}
                        </div>
                    ) : (
                        <div className="mt-8 rounded-lg border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
                            New proposals coming soon.
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
